import { render, staticRenderFns } from "./VircosMaterialLists.vue?vue&type=template&id=519a55ba&scoped=true&"
import script from "./VircosMaterialLists.vue?vue&type=script&lang=js&"
export * from "./VircosMaterialLists.vue?vue&type=script&lang=js&"
import style0 from "./VircosMaterialLists.vue?vue&type=style&index=0&id=519a55ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a55ba",
  null
  
)

export default component.exports